import React from "react";
import analytics from "web/script/analytics/analytics";
import styles from "./infeed-product-list-cta.css";

type InfeedProductListCTAProps = {
    cta?: string;
    links?: Link[];
};

type Link = {
    image: string;
    link: string;
    title: string;
};

const TEMP_CTA = "Looking for Something in particular?";
const TEMP_LINKS = [
    {
        title: "Raincoats and Trench Coats",
        image:
            "https://cdna.lystit.com/1040/1300/n/photos/asos/89e586d4/asos-Beige-Trench-Coat-With-Detachable-Leather-Look-Hood.jpeg",
        link: "/shop/trench-coats/",
    },
    {
        title: "Parka coats",
        image:
            "https://cdna.lystit.com/1040/1300/n/photos/filippa/9a8439fa/filippa-k-Black-Puffer-Down-Parka.jpeg",
        link: "/shop/parka-coats/",
    },
];

export function InfeedProductListCTA({
    cta = TEMP_CTA,
    links = TEMP_LINKS,
}: InfeedProductListCTAProps): JSX.Element {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <h4 className={styles.heading}>{cta}</h4>
            </div>
            <div className={styles.flex}>
                {links.map(({ image, link, title }, i) => (
                    <>
                        <div key={link} className={styles.item}>
                            <a
                                className={styles.itemLink}
                                href={link}
                                onClick={(): void => {
                                    analytics.event("click", "uf_infeed_cta", title);
                                }}
                            >
                                <img
                                    className={styles.itemImage}
                                    src={image}
                                    height={250}
                                    width={200}
                                />
                                <h5 className={styles.itemHeader}>{title}</h5>
                            </a>
                        </div>
                        {i % 2 === 0 ? <div className={styles.keyLine} /> : null}
                    </>
                ))}
            </div>
        </div>
    );
}

export default InfeedProductListCTA;
